import React from 'react'

import { classnames, Button, ArrowRight as ArrowRightIcon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, number, bool } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

import CountdownTimer from '../../Shared/CountdownTimer'

function SaleOffBar({ barColor, content = '', discountPhrase = '', discount = 0, endingDate = 0, useTimer = false, locale = 'en' }) {
  // Don't render if timer is enabled but date is invalid or expired
  if (useTimer && (!endingDate || endingDate <= Date.now())) {
    return null
  }

  const secondaryBarColor = barColor === 'red' ? 'is-secondary-color' : `${barColor}-gradient`

  return (
    <a href="/3d-models?sale_off=1" className="timer-strip--top-bar">
      <div className={`timer-strip ${secondaryBarColor}`}>
        <div className="timer-row">
          <div className={classnames(
            'timer-strip__item',
            'timer-strip__item--content',
            !useTimer && 'timer-strip__item--content-no-timer'
          )}>
            {content}
          </div>

          {discountPhrase === 'up to' && (
            <div className={classnames(
              'timer-strip__item',
              'timer-strip__item--info',
              !useTimer && 'timer-strip__item--info-no-timer'
            )}>
              <div className="u-mr10">🚀 UP TO </div>
              <div className="u-mr10">{discount}%</div>
              <div>OFF 🚀</div>
            </div>
          )}

          {useTimer && (
            <div className="timer-strip__item timer-strip__item--time">
              <span className="timer-strip__item--text u-mr10">Sale ends in</span>
              <div className="big-text">
                <CountdownTimer targetDate={endingDate} />
              </div>
            </div>
          )}

          <Button
            size="small"
            onClick={() => window.location.href = '/3d-models?sale_off=1'}
            customClass="timer-strip__item--button"
            trailIcon={<ArrowRightIcon width="16" height="16" />}
          >
            {i18n.t('sale_off_bar.find_deals', { ns: 'rails', lng: locale })}
          </Button>
        </div>
      </div>
    </a>
  )
}

SaleOffBar.propTypes = {
  barColor: string.isRequired,
  content: string,
  discountPhrase: string,
  discount: number,
  endingDate: number,
  useTimer: bool,
  locale: string,
}

export default SaleOffBar
